// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../Button';
import CourseIncompletedImage from '../../../../assets/images/course-content-skipped-pic.svg';
import CourseCompletedImage from '../../../../assets/images/course-content-completed-pic.svg';

const otherS = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  `,
  Message: styled.div`
    margin-top: 12px;
    font: 18px Noto Sans TC;
    color: #434343;
    text-align: center;
  `,
  CourseCompletedImage: styled.img.attrs({ src: CourseCompletedImage, alt: 'course-completed-image'})`
  `,
  CourseIncompletedImage: styled.img.attrs({ src: CourseIncompletedImage, alt: 'course-incompleted-image'})`
  `,
  Button: styled(Button)`
    margin-top: 24px;
    box-shadow: 0px 1px 4px 0px #00000040;
    padding: 9px 36px;
    display: flex;

  `
};

export const S = {
  ...otherS
}
